import styled from 'styled-components';
export const ImageEvidence = styled('img')`
  width: 100%;
  height: 380px;
  max-width: 500px;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
`;

export const NoDataText = styled('div')`
  height: 380px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #000;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
`;

export const LabelInput = styled('label')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: #fff;
  border-radius: 10px;
`;
export const UploadButton = styled('div')`
  width: 171px;
  height: 40px;
  border-radius: 10px;
  background-color: #9dd049;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
`;
